import { Component, Input } from '@angular/core';
import { VentanaUtils } from '../../utils/ventana.utils';
import { Contexto } from '../../models/contexto';
import { AsistenteVentanaComponent } from '../../components/asistente-ventana/asistente-ventana.component';

declare function notificarCierre();

@Component({
  selector: 'app-cabezal',
  templateUrl: './cabezal.component.html',
  styleUrls: ['./cabezal.component.scss']
})
export class CabezalComponent {
  @Input() modo: string = "asistente";
  @Input() permite_chat: boolean = false;
  @Input() public ctx: Contexto;
  constructor(public window: VentanaUtils,
    private asistenteVentana: AsistenteVentanaComponent
  ) {

  }

  cerrar() {
    this.ctx.idNodo = undefined;
    notificarCierre();
    this.window.close.emit();
  }

  minimizar() {
    this.asistenteVentana.minimizarMaximizar();
  }
}
